import { styled } from 'styled-components';

export const TableWrapper = styled.div`
  min-height: calc(100vh - 261px);
  margin-top: -16px;
  border: 1px solid ${({ theme }) => theme.colours.canvas.primary.main};
  border-top: none;

  table {
    thead {
      height: 40px;
    }

    tbody {
      a {
        text-decoration: none;
      }
      a:hover {
        text-decoration: underline;
      }
    }
  }
`;
TableWrapper.displayName = 'TableWrapper';

export const DownloadButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  z-index: 1;
`;
DownloadButtonWrapper.displayName = 'DownloadButtonWrapper';

export const ScoutSearch = styled.div`
  position: absolute;
  right: 45px;
  z-index: 2;
`;
ScoutSearch.displayName = 'ScoutSearch';

export const ScoutHeader = styled.div`
  display: flex;
  height: 35px;
  align-items: center;
  margin: 0 ${({ theme }) => theme.sizing.small}
    ${({ theme }) => theme.sizing.medium} ${({ theme }) => theme.sizing.small};
`;
ScoutHeader.displayName = 'ScoutHeader';

export const ScoutPlayersWrapper = styled.div`
  position: relative;
  width: 100%;
`;
ScoutPlayersWrapper.displayName = 'ScoutPlayersWrapper';

export const ScoutPlayersStatusWrapper = styled.div`
  display: flex;
  height: calc(100vh - 316px);
  width: 100%;
  vertical-align: bottom;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};

  svg {
    color: ${({ theme }) => theme.colours.messaging.info.main};
  }
`;
ScoutPlayersStatusWrapper.displayName = 'ScoutPlayersStatusWrapper';

export const ScoutPlayersPagination = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.sizing.medium};
  gap: ${({ theme }) => theme.sizing.small};
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  align-items: center;

  > div:first-child {
    margin-left: auto;
  }

  ol {
    gap: ${({ theme }) => theme.sizing.small};
  }
`;
ScoutPlayersPagination.displayName = 'ScoutPlayersPagination';
